<template>
    <div>
        <b-modal id="ExternalSearchItem" :title="'Інформація про книгу'" size="size" footer-class="reader-footer" content-class="reader-content">
            <template v-slot:default>
                <loading :active.sync="isLoading"
                         :is-full-page="true"
                         color="green"
                         loader="dots"
                ></loading>
                <div class="row">
                    <table>
                        <tr>
                            <td>Сервер</td>
                            <td>{{item.server.name}}</td>
                        </tr>
<!--                        <tr v-for="param in item.fields">-->
<!--                            <td>{{param.name}}</td>-->
<!--                            <td>{{param.value}}</td>-->
<!--                        </tr>                        -->
                        <tr v-for="(values, name) in item.fields">
                            <td valign="top">{{name}}</td>
                            <td>{{ values.map(u => u).join(', ') }}</td>
                        </tr>
                    </table>
                </div>
            </template>

            <template v-slot:modal-footer>
                <div class="row w-100 m-b-30 text-center" v-if="item.server.position">
                    <div class="col-4">
                        <button class="btn btn-primary" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                            Переглянути повну інформацію
                        </button>
                    </div>
                    <div class="col-4">
                        <button class="btn btn-success" @click="importItem(item.server.id, item.server.position);$bvModal.hide('externalSearchItem');">
                            Імпортувати
                        </button>
                    </div>
                    <div class="col-4">

                    </div>
                </div>
                <div class="row w-100 m-b-20 text-center" style="height:10px">
                    <div class="invalid-feedback">

                    </div>
                </div>
                <div class="row">
                    <div class="collapse" id="collapseExample">
                        <div class="card card-body" v-html="item.full_record">

                        </div>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';

    export default {
        name: "ExternalSearchItem",
        components:{
            Loading,
        },
        props:['item'],
        mounted() {

        },
        data() {
            return {
                isLoading:false,
            }
        },
        methods:{
            importItem(serverId, position) {
                let current = this;
                this.isLoading = true;
                let query = new URLSearchParams(window.location.search).get('query');
                axios.get('/library/external-search/import',{params:{server_id:serverId,position:position,query:query}}).then(response => {
                    this.isLoading = false;
                    let id = response.data.item.id;
                    if (response.data.message) {
                        $(".invalid-feedback").show();
                        $(".invalid-feedback").html("<span>" + response.data.message + "</span>");
                        $(".invalid-feedback").fadeOut(4000);
                    } else {
                        window.open('/library/descriptions/' + id + '/edit', '_blank');
                        Swal.fire('Запис успішно імпортовано!', '', 'success');
                    }
                }).catch(function(error) {
                    current.isLoading = false;
                    Swal.fire('Виникла помилка', error.message, 'error');
                });
            },
            moment: function (date) {
                return moment(date);
            },
        }
    }

</script>

<style scoped>

</style>